
/**
 * @param {ProductVariantCollection} productVariant
 *  * There can be multiple full size variants with different prices, sizes, etc.
 * We need to hide those variants whose price is different from the featured variant price
 * because these variants can have same colors but different price / size also on quickshop
 * we display other full size variants as button below sample, full size buttons not as a color swatch
 * so if we want to make shade and color swatch both to be consistent we need to hide those variants
 * whose price is different from the featured variant price
 * @param {ProductVariantCollection} selectedVariant
 * @returns {boolean}
 */
const shouldHideShadeUtil = ({
  productVariant,
  selectedVariant
}) => {
  return productVariant?.price !== selectedVariant?.price
}

export default shouldHideShadeUtil
